// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_oi-0";
export var discountCodeInput = "_oi-1";